import React, {useState, useEffect, useLayoutEffect, useCallback} from "react";
import { useParams } from 'react-router';
import { formattedMoney, stripHtml, encodeBase64, decodeBase64, dispatchSdKEvent, sdkFunctions, setSdkData } from "../../../_utils";
import {PhysicalCardFront, TextMessage, Postage, VideoMessage, AudioMessage, Buttons, Code } from "./_sections";
import { TranslationsContext } from "./../../_contexts";
import {Button} from "./../../_components";

function PhysicalDetail({ currentStep, previewSettings, preview, giftCardData, previewVisible, togglePreview, inDashboard }) {
  const [giftCard, setGiftCard] = useState({});
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);
  const [videos, setVideos] = useState([]);
  const [currentPreview, setCurrentPreview] = useState("show_landing_preview");
  const [additionalCardWrapClasses, setAdditionalCardWrapClasses] = useState([]);
  const [translations, setTranslations] = useState({});
  const {token} = useParams();
  const previewClassName = "gc__preview-page";// preview === true ? "gc__preview-page" : "page-width site-wrapper wrapper main-content container";
  const videoUuid = preview == true ? giftCardData.video_hash : giftCard.video_hash;
  const [styleVars, setStyleVars] = useState({});

  useEffect(() => {
    if (preview) {
      setGiftCard(giftCardData);
      setSettings(previewSettings);
      setTranslations(previewSettings.translations);
      setLoading(false);
    } else {
      fetch(`${window.Shopify?.routes?.root}a/gc/api/giftcards/${token}`)
      .then(res => res.json())
      .then(res => {
        document.cookie = `discount=${res.giftcard.issued_gift_card_code};path=/;secure;samesite=strict`;
        document.cookie = `discount_code=${res.giftcard.issued_gift_card_code};path=/;secure;samesite=strict`;
        setGiftCard(res.giftcard);
        setSettings(res.settings);
        setTranslations(res.settings.translations);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
    }

  }, []);

  useEffect(() => {

    if (!videoUuid || videoUuid === "") return;

    setVideoLoading(true);

    fetch(`${window.Shopify?.routes?.root}a/gc/api/giftcard/videos/${videoUuid}`)
    .then(res => res.json())
    .then(res => {
      if (res.status == "error") {
        setVideoError(true);
      } else {
        setVideos(res.videos);
      }
      setVideoLoading(false);
    })
    .catch(err => {
      console.warn("Error: ", err);
      setVideoError(true);
      setVideoLoading(false);
    })
    ;

  }, [videoUuid]);

  useEffect(() => {
    if (Object.keys(settings).length !== 0) {
      setStyleVars({
        "--gc__var-brand_color": settings.global.appearance.brand_color,
        "--gc__var-accent_color": settings.global.appearance.accent_color,
        "--gc__var-button_text_color": settings.global.appearance.button_text_color,
      })
    }
  }, [settings]);

  /**
   * Set the correct preview to show by default - only in preview mode.
   */
  useEffect(useCallback(() => {
    if ( preview ) {
      setGiftCard(giftCardData);
    }
  },[giftCardData]), [giftCardData]);

  /**
   * Set the correct preview to show by default
   */
  useEffect(useCallback(() => {

    if (!settings || !Object.keys(settings).length) return;

    if (
      settings.digital.appearance.enable_email_preview === "1" &&
      (settings.digital.appearance.enable_landing_preview === "0")
    ) {
      setCurrentPreview("show_email_preview");
    } else {
      setCurrentPreview("show_landing_preview");
    }

  },[currentPreview]), [settings]);

  /**
   * Make sure the preview updates in the admin
   */
  useEffect(useCallback(() => {
    if ( preview ) {
      setSettings(previewSettings);
      if (
        previewSettings.digital.appearance.enable_email_preview === "1" &&
        (previewSettings.digital.appearance.enable_landing_preview === "0")
      ) {
        setCurrentPreview("show_email_preview");
      } else {
        setCurrentPreview("show_landing_preview");
      }
    }
  }, [settings]), [previewSettings]);

  useEffect(() => {
    setVideoError(false);
  }, [giftCardData?.video_hash, giftCard?.video_hash]);


  useLayoutEffect(() => {

    setSdkData('page', {
      'step': currentStep,
    });

    dispatchSdKEvent('gcp-page-loaded');

    // This is handled by useLayoutEffect below.
    if (currentStep === "greeting_card") {


      if (additionalCardWrapClasses.includes("gc__animated-initial-load")) {

        // After the first load, we don't do the skew in animation, but need to close the card instead
        setAdditionalCardWrapClasses(["gc__animated-initial-load", "gs__close-card-animation"]);

        setTimeout(() => {

          setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__greeting-card-animation-start"]);

          setTimeout(() => {
            setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__greeting-card-step-animation-done"]);
          }, 1000);

        }, 300);

        return;

      } else {

        // This sets the Skew in animation.
        setAdditionalCardWrapClasses([""]);

        // We wait 1 second for skew to finish, then start the next animation
        setTimeout(() => {

          setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__greeting-card-animation-start"]);

          setTimeout(() => {
            setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__greeting-card-step-animation-done"]);
          }, 1000);

        }, 1000);

      }

      return;

    }

    if (currentStep === "gift_card") {

      // Don't chang the animation if it is already complete
      if (additionalCardWrapClasses.includes("gc__gift-card-step-animation-done")) {
        return;
      }

      setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__gift-card-animation-start"]);

      setTimeout(() => {

        setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__gift-card-step-animation-done"]);

      }, 300);

      return;

    }

    if (typeof(currentStep) == 'undefined') {


      // setTimeout(() => {

        // We wait 1 second for skew to finish, then start the next animation
        setTimeout(() => {

          setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__greeting-card-animation-start"]);

          setTimeout(() => {
            setAdditionalCardWrapClasses(["gc__animated-initial-load", "gc__greeting-card-step-animation-done"]);
          }, 1000);

        }, 4000);


      // }, 4000);


    }

  }, [currentStep]);

  useLayoutEffect(() => {}, []);

  const shouldShow = (settingValue, previewStateValue) => {

    if (settingValue !== "1" && settingValue !== true) {
      return false;
    }

    if (currentPreview !== previewStateValue) {
      return false;
    }

    return true;

  };

  const bottomImage  = settings?.physical?.greeting_card?.inside_bottom_background_image;

  return loading === false ? (
    <TranslationsContext.Provider value={translations.landing}>
      {preview === false && <style dangerouslySetInnerHTML={{__html: decodeBase64(settings.global.appearance.custom_css) }} />}
      <div className={previewClassName} style={styleVars}>
        <div id="gcpMobilePreviewActions" className="gc__hidden_desktop">
          <Button
            type={"button"}
            fullWidth={true}
            onClick={togglePreview}
          >
          {previewVisible === true ? translations.purchase.close_preview : translations.purchase.open_preview}
          </Button>
        </div>
          <div className="gc__container" data-section="greeting-card">
            <div
            className={`gc__grid-item gc__physical-card-wrapper ${additionalCardWrapClasses.join(' ')}`}
            id="gcpAnimatedCardWrapper"
            >
              <div id="gcpAnimatedCardBackround"></div>
              <div
                id="gcpAnimatedCard"
                className="gc__animated-card gc__physical-card"
              >
                <PhysicalCardFront
                  settings={settings}
                  preview={preview}
                  giftCard={giftCard}
                />
                <div className="gc__animated-card-inside">
                  <div
                    className="gc__greeting_bottom"
                    style={{
                      backgroundImage: (bottomImage) ? `url('${bottomImage}')` : undefined,
                      backgroundSize: (bottomImage) ? "contain" : undefined
                    }}
                  />
                  {
                    (inDashboard && window.location.pathname.includes("return_address")) ?
                      <Postage settings={previewSettings} />
                    : (giftCard.message_text) ?
                      <TextMessage
                        giftCard={giftCard}
                        salutation={giftCard.message_salutation}
                        messageText={giftCard.message_text}
                        recipientName={giftCard.recipient_name}
                        messageFrom={giftCard.message_from}
                        translation={translations}
                        fontFamily={settings.global?.appearance?.message_font_family || null}
                      />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
      </div>
    </TranslationsContext.Provider>
  ) : (
    <></>
  );
};

export default PhysicalDetail;
